var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotepad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71657 16.5387C1.9701 18.8006 3.80858 20.5965 6.082 20.706C7.65335 20.7817 9.25854 20.821 11.0007 20.821C12.7428 20.821 14.348 20.7817 15.9194 20.706C18.1928 20.5965 20.0313 18.8006 20.2848 16.5387C20.4555 15.0155 20.5956 13.4538 20.5956 11.863C20.5956 10.2722 20.4555 8.71053 20.2848 7.18733C20.0313 4.92544 18.1928 3.12954 15.9194 3.02004C14.348 2.94436 12.7428 2.90503 11.0007 2.90503C9.25854 2.90503 7.65335 2.94436 6.082 3.02004C3.80858 3.12954 1.9701 4.92543 1.71657 7.18733C1.54584 8.71053 1.40576 10.2722 1.40576 11.863C1.40576 13.4538 1.54584 15.0155 1.71657 16.5387Z",
    fill: "white",
    fillOpacity: 0.04,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2.35714
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47046 1.17859L7.47046 5.16873",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2.35714,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5203 1.17859L14.5203 5.16873",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2.35714,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotepad);
export default __webpack_public_path__ + "static/media/notepad.b4796841ab19aac9009add01c707d85e.svg";
export { ForwardRef as ReactComponent };